import useMediaLayout from 'use-media';

export const useMobile = () => {
  return useMediaLayout({ maxWidth: '880px' });
};
